/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { MdArrowForwardIos, MdOutlineArrowBackIosNew } from 'react-icons/md';
import { Button, Label } from 'reactstrap';
import { TYPE_OF_OFFER_AND_DEMAND } from 'helper/constants';
import DateFormatter from 'components/DateFormatter';
import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';

const Summary = ({
  index,
  id,
  trader,
  totalQty,
  validityInHours,

  rate,
  rateUnit,
  createdAt,
  handlePrevNext,
  max,
  buttonDisabled,
  state,
  city,
  status,
  quantityUnit,
  bidType,
  ...rest
}) => {
  const [showMore, setShowMore] = useState(false);
  // const inputFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSZ'; // Format of the input date string
  // const outputFormat = 'YYYY-MM-DD'; // Desired output format

  // const convertedDate = moment(inputDateString, inputFormat).format(
  //   outputFormat
  // );

  const checkType = rest?.offerType || rest?.demandType;
  const selectedGrade =
    (bidType === 'offer' ? rest?.grade : rest?.grades?.[0]) ||
    rest?.grade ||
    rest?.grades?.[0];
  // const location =
  //   checkType === TYPE_OF_OFFER_AND_DEMAND.FOREIGN
  //     ? rest?.portOfDischarge?.name
  //     : `${city?.cityName}, ${state?.stateName}`;

  return (
    <>
      <div className="d-flex align-items-center justify-content-between position-relative ">
        <div>
          <h4 className="f-16 fw-semibold mb-0">
            {selectedGrade?.name || '-'}
          </h4>
        </div>
        <div className="d-flex align-items-center slide-button ms-auto">
          {buttonDisabled && (
            <Button
              className="text-decoration-none p-0"
              type="button"
              color="link"
              onClick={(e) => handlePrevNext(e, 'prev')}
              disabled={index <= 0}
            >
              <MdOutlineArrowBackIosNew
                size={15}
                className="me-2"
                color="#525252"
              />
            </Button>
          )}
          {buttonDisabled && (
            <Button
              className="text-decoration-none p-0"
              color="link"
              type="button"
              onClick={(e) => handlePrevNext(e, 'next')}
              disabled={index === max - 1}
            >
              <MdArrowForwardIos size={15} color="#525252" />
            </Button>
          )}
        </div>
      </div>
      <div>
        <div className="border p-4 rounded mt-2 mb-4 position-relative pb-0">
          <div className="d-flex flex-wrap justify-content-between details-row col5">
            <div>
              <Label className="f-12 fw-medium text-gray text-uppercase  d-block mb-0 form-label">
                Id
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">{id}</p>
            </div>
            <div>
              <Label className="f-12 fw-medium text-gray text-uppercase  d-block mb-0 form-label">
                {bidType === 'offer' ? 'Seller' : 'Buyer'}
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">
                {trader?.firstName}
              </p>
            </div>
            <div>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Total Quantity
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">
                {NumberWithCommasFormat(totalQty)} {quantityUnit}
              </p>
            </div>
            <div>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                {bidType === 'offer' ? 'Offer' : 'Demand'} Type
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">
                {bidType === 'offer' ? rest?.offerType : rest?.demandType}
              </p>
            </div>
            <div>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Location
              </Label>
              {checkType === TYPE_OF_OFFER_AND_DEMAND.FOREIGN ? (
                rest?.portsOfDischarge && rest.portsOfDischarge.length > 0 ? (
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    {rest.portsOfDischarge
                      .map(
                        (portOfDischarge) =>
                          portOfDischarge?.name || 'Not Available',
                      )
                      .join(', ')}
                  </p>
                ) : (
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    Not Available
                  </p>
                )
              ) : (
                <p className="f-14 mb-0 font-manrope fw-semibold">
                  {city?.cityName}, {state?.stateName}
                </p>
              )}
            </div>

            {/* <div className="text-end">
              
            </div> */}

            {showMore && (
              <>
                <div>
                  <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                    {bidType === 'offer' ? 'Seller NO.' : 'Buyer NO.'}
                  </Label>
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    {trader?.phone}
                  </p>
                </div>
                <div>
                  <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                    Validity(Hours)
                  </Label>
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    {validityInHours}
                  </p>
                </div>
                <div>
                  <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                    Dated
                  </Label>
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    <DateFormatter
                      className="date-inline flex-nowrap"
                      dateTime={createdAt}
                    />
                  </p>
                </div>
                <div>
                  <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                    Rate
                  </Label>
                  <p className="f-14 mb-0 font-manrope fw-semibold">
                    {/* {rateUnit?.currencyName} {rate} */}
                    {currencyToLocal(rate, rateUnit?.isoCurrencyCode)}/
                    {quantityUnit}
                  </p>
                </div>
                <div>
                  <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                    Status
                  </Label>
                  <p className="f-14 mb-0 font-manrope fw-semibold">{status}</p>
                </div>
              </>
            )}
          </div>
          {showMore ? (
            <Button
              color="link"
              className="text-decoration-none text-nowrap viewmore font-manrope f-12 fw-bold text-dark-525 p-0"
              onClick={() => setShowMore(false)}
            >
              <span>View less</span>
            </Button>
          ) : (
            <Button
              color="link"
              className="text-decoration-none text-nowrap viewmore font-manrope f-12 fw-bold text-dark-525 p-0"
              onClick={() => setShowMore(true)}
            >
              <span>View more</span>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Summary;
